var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoInfoComerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 104,
    viewBox: "0 0 102 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 58C89.0163 58 102 45.0163 102 29C102 12.9837 89.0163 0 73 0C56.9837 0 44 12.9837 44 29C44 45.0163 56.9837 58 73 58Z",
    fill: "#DDDDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 11C63.0745 11 55 19.0745 55 29C55 32.4168 55.9623 35.7422 57.7822 38.6164C58.1405 39.183 58.9471 39.3657 59.5161 39.0057C60.1015 38.6351 60.2759 37.8572 59.9054 37.2718C58.3401 34.8004 57.513 31.9409 57.513 29C57.513 20.4607 64.4601 13.5136 73 13.5136C81.5399 13.5136 88.487 20.4607 88.487 29C88.487 37.5393 81.5393 44.4864 73 44.4864C72.6675 44.4864 72.3303 44.4753 72.0002 44.4548L71.9147 44.4519C71.2562 44.4519 70.7071 44.9688 70.6656 45.6285C70.6439 45.9633 70.7545 46.287 70.9758 46.5387C71.1977 46.791 71.5044 46.9415 71.8392 46.9631C72.2244 46.9883 72.6148 47 73.0006 47C82.9261 47 91.0006 38.9255 91.0006 29C91 19.0745 82.9255 11 73 11Z",
    fill: "#565656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9987 19.0762C71.8473 19.0762 70.9102 20.0139 70.9102 21.1659C70.9102 22.3173 71.8473 23.2539 72.9987 23.2539C74.1502 23.2539 75.0873 22.3173 75.0873 21.1659C75.0873 20.0139 74.1502 19.0762 72.9987 19.0762Z",
    fill: "#565656"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9967 26.3887C72.1315 26.3887 71.4297 27.0899 71.4297 27.9557V37.3561C71.4297 38.2213 72.131 38.9231 72.9967 38.9231C73.8625 38.9231 74.5637 38.2218 74.5637 37.3561V27.9557C74.5637 27.0899 73.8625 26.3887 72.9967 26.3887Z",
    fill: "#565656"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1559 55.1875H3.84766V99.2667H67.1559V55.1875Z",
    fill: "#F2C94C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 51.7852V55.9269C0 59.9206 3.10625 63.0269 7.1 63.0269C11.0938 63.0269 14.2 59.9206 14.2 55.9269V51.7852H0Z",
    fill: "#FF1E2F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1992 51.7852V55.9269C14.1992 59.9206 17.3055 63.0269 21.2992 63.0269C25.293 63.0269 28.3992 59.9206 28.3992 55.9269V51.7852H14.1992Z",
    fill: "#CED6E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3984 51.7852V55.9269C28.3984 59.9206 31.5047 63.0269 35.4984 63.0269C39.4922 63.0269 42.5984 59.9206 42.5984 55.9269V51.7852H28.3984Z",
    fill: "#FF1E2F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6016 51.7852V55.9269C42.6016 59.9206 45.7078 63.0269 49.7016 63.0269C53.6953 63.0269 56.8016 59.9206 56.8016 55.9269V51.7852H42.6016Z",
    fill: "#CED6E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8008 51.7852V55.9269C56.8008 59.9206 59.907 63.0269 63.9008 63.0269C67.8945 63.0269 71.0008 59.9206 71.0008 55.9269V51.7852H56.8008Z",
    fill: "#FF1E2F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 51.785L19.525 41.7266H9.02296L0 51.785H14.2Z",
    fill: "#EB0012"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3992 51.785L30.1742 41.7266H19.5242L14.1992 51.785H28.3992Z",
    fill: "#E8EAE9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5984 51.785L40.8234 41.7266H30.1734L28.3984 51.785H42.5984Z",
    fill: "#EB0012"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7992 51.785L51.4742 41.7266H40.8242L42.5992 51.785H56.7992Z",
    fill: "#E8EAE9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0016 51.785L61.9786 41.7266H51.4766L56.8016 51.785H71.0016Z",
    fill: "#EB0012"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1255 33H9.02344V41.727H62.1255V33Z",
    fill: "#415A6B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0617 70.7188H9.76172V99.2667H31.0617V70.7188Z",
    fill: "#415A6B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1606 70.7188H36.6836V95.125H63.1606V70.7188Z",
    fill: "#415A6B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2011 73.6777H39.6406V92.1673H60.2011V73.6777Z",
    fill: "#8AD7F8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71 99.2676H0V104.001H71V99.2676Z",
    fill: "#CED6E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoInfoComerce);
export default __webpack_public_path__ + "static/media/icon-noInfo-comerce.cf3322c94bb7641d4c0fcec32ce2b075.svg";
export { ForwardRef as ReactComponent };